import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  [x: string]: any;
  //For US 8229
  private isRefreshCalled = new BehaviorSubject<any>({ flag: false, from: '' });
  public $isRefreshCalled = this.isRefreshCalled.asObservable();
  private isMetricsLoaded = new BehaviorSubject<any>({ flag: false, from: '' });
  public $isMetricsLoaded = this.isMetricsLoaded.asObservable();

  constructor() { }

  public setItem(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  //For US 8229
  public updateRefreshClick(data: boolean, from: string = '') {
    this.isRefreshCalled.next({ flag: data, from: from });
  }

  public updateMetricsLoading(data: boolean, from: string) {
    this.isMetricsLoaded.next({ flag: data, from: from });
  }

  public getItem(key: any) {
    const item: string = localStorage.getItem(key);
    try {
      if (item) {
        return JSON.parse(item);
      }
    } catch (error) {
      console.log(error);
    }
    return null;
  }

  public removeItem(key: any) {
    localStorage.removeItem(key);
  }


}
